import { Maybe } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'inParentheses', standalone: true })
export class InParenthesesPipe implements PipeTransform {
  public transform(value: Maybe<string | number>): Maybe<string | number> {
    return value != null && value !== '' ? `(${ value })` : value;
  }
}
